import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";

Vue.use(Vuex);

import { loginUser } from "./login-user";

export default new Vuex.Store({
  state: {
    dateTime1: moment()
      .clone()
      .startOf("week"),
    dateTime2: moment().endOf("day"),
  },
  getters: {
    dateTime1(state) {
      return state.dateTime1;
    },
    dateTime2(state) {
      return state.dateTime2;
    },
  },
  mutations: {
    setDateTime1(state, dateTime1) {
      state.dateTime1 = dateTime1;
    },
    setDateTime2(state, dateTime2) {
      state.dateTime2 = dateTime2;
    },
  },
  actions: {},
  modules: {
    loginUser,
  },
  strict: process.env.NODE_ENV !== "production",
});
